var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8534 7.91128V20C29.8534 21.8379 28.3581 23.3333 26.5201 23.3333H3.48006C1.64206 23.3333 0.146729 21.8379 0.146729 20V2.99995C0.146729 2.34162 0.426728 1.71095 0.915395 1.26928C1.43806 0.796283 2.23906 0.812283 2.7424 1.30562L11.7347 10.1126C13.5351 11.8763 16.4651 11.876 18.2651 10.113L25.1881 3.33328H7.46873C7.46873 3.33128 4.80406 0.665283 4.80406 0.665283H7.49606C7.49606 0.666617 27.5201 0.666616 27.5201 0.666616C28.1004 0.666616 28.6567 0.881283 29.0867 1.27062C29.3587 1.51728 29.5171 1.86562 29.5241 2.23295C29.5311 2.60028 29.3864 2.95428 29.1241 3.21128L20.1314 12.0183C17.3027 14.7889 12.6987 14.7889 9.86906 12.018L2.8134 5.10762V20C2.8134 20.3676 3.1124 20.6666 3.48006 20.6666H26.5201C26.8877 20.6666 27.1867 20.3676 27.1867 20V7.91162C27.1854 7.91162 29.8521 5.24628 29.8521 5.24628C29.8521 5.24628 29.8521 7.91128 29.8534 7.91128Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWhite);
export default __webpack_public_path__ + "static/media/message-white.a32e21a18247db775a3d4d27f43e512e.svg";
export { ForwardRef as ReactComponent };